"use client";

import { formOptions } from "@tanstack/react-form";

export const setFormFieldToSessionStorage = (
  field: string,
  value: unknown,
  sessionStorageKey: string,
) => {
  if (typeof window === "undefined") return;

  try {
    const savedFormData = sessionStorage.getItem(sessionStorageKey);
    const parsedFormData = savedFormData
      ? JSON.parse(savedFormData)
      : undefined;

    sessionStorage.setItem(
      sessionStorageKey,
      JSON.stringify({ ...parsedFormData, [field]: value }),
    );
  } catch {
    console.warn(`Failed to write ${sessionStorageKey} to sessionStorage.`);
  }
};

export const getSavedFormData = (sessionStorageKey: string) => {
  if (typeof window === "undefined") return undefined;

  const savedFormData = sessionStorage.getItem(sessionStorageKey);

  if (!savedFormData) return undefined;

  try {
    return JSON.parse(savedFormData);
  } catch {
    console.warn(`Failed to parse ${sessionStorageKey} from sessionStorage.`);
    return undefined;
  }
};

export const setFormData = <T extends Record<string, unknown>>(
  sessionStorageKey: string,
  formData: T,
) => {
  if (typeof window !== "undefined") {
    try {
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(formData));
    } catch {
      console.warn(`Failed to write ${sessionStorageKey} to sessionStorage.`);
    }
  }
};

export const clearFormData = (sessionStorageKey: string) => {
  if (typeof window === "undefined") return;

  try {
    sessionStorage.removeItem(sessionStorageKey);
  } catch {
    console.warn(`Failed to clear ${sessionStorageKey} from sessionStorage.`);
  }
};

export const formOpts = formOptions({});
